// @flow
import React from 'react';
import { Image } from '@finect/tabular-components/Image';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { Section } from '@finect/tabular-core/Section';
import { DatalayerScene } from '@finect/front-gtm';
import { Head } from '@finect/tabular-components/Head';
import { buildOpenGraph, buildTwitter } from '../../data/seo';

import {
  Benefit,
  BenefitIMG,
  BenefitInfo,
  SectionTitle,
  NewSectionInner,
  FaqItem,
  HeroMortgages,
  BottomCTAMortgages,
  HighlightsCompaniesContent,
  LandingContent,
  LogoContent,
  HighlightsCompanies
} from '../../components';

// $FlowFixMe
import objetivosIMG from '../../assets/mortgages.webp';
import { ButtonStart } from './partials';

type Props = {
  staticContext?: Object,
  toggleModal: Function,
  location: Object,
  history: Object
};

type State = {
  enterpriseAdvisers: Object
};

class Mortgages extends React.Component<Props, State> {
  static loadInitialData = () =>
    finectAPI({
      version: 'v4',
      path: `contents/profiles/organizations?filter=tag+eq+34484&orderby=evergreen`,
      method: 'GET',
      onSuccess: ({ data }: { data: Array<Object> }) => data,
      onError: () => {}
    });

  state =
    typeof window === 'undefined'
      ? {
        enterpriseAdvisers: (this.props.staticContext && this.props.staticContext.initialData.landing) || []
      }
      : {
        enterpriseAdvisers: (window.initialData && window.initialData.landing) || []
      };

  componentDidMount() {
    if (!this.state.enterpriseAdvisers.length) {
      Mortgages.loadInitialData().then(enterpriseAdvisers =>
        this.setState({ enterpriseAdvisers: enterpriseAdvisers || [] }));
    }
  }

  render() {
    const { toggleModal } = this.props;
    const { enterpriseAdvisers } = this.state;

    return (
      <LandingContent>
        <Head
          title="Hipotecas Finect"
          withoutName
          description="Encuentra la mejor hipoteca en solo 2 minutos."
          canonical="/hipotecas/solicitar-hipoteca"
          robots="index, follow"
          openGraph={buildOpenGraph({
            title: 'Hipotecas Finect',
            description: 'Encuentra la mejor hipoteca en solo 2 minutos.',
            url: '/hipotecas/solicitar-hipoteca'
          })}
          twitter={buildTwitter({
            title: 'Hipotecas Finect',
            description: 'Encuentra la mejor hipoteca en solo 2 minutos.'
          })}
        />
        <DatalayerScene /*pageType="home"*/ pageId="mortgages" />

        <HeroMortgages toggleModal={toggleModal} />

        <Section>
          <HighlightsCompanies>
            <SectionTitle title="Nuestros partners" noMargin />
            <HighlightsCompaniesContent>
              {enterpriseAdvisers && enterpriseAdvisers.length > 0
                ? enterpriseAdvisers.map((enterprise, index) => (
                  <LogoContent key={index} qty={enterpriseAdvisers.length}>
                    {/* <a href={`/grupos/${enterprise.alias}`} title={`Ver ${enterprise.displayName} en Finect`}> */}
                    <span>
                      <Image
                        src={`/image/${enterprise.logo}`}
                        height={180}
                        format="webp"
                        alt={enterprise.displayName}
                      />
                    </span>
                    {/* </a> */}
                  </LogoContent>
                ))
                : null}
            </HighlightsCompaniesContent>
          </HighlightsCompanies>
        </Section>

        <Benefit>
          <div>
            <BenefitIMG>
              <img src={objetivosIMG} alt="Alcanza tus objetivos" width="700" height="467" loading="lazy" />
            </BenefitIMG>
          </div>
          <BenefitInfo>
            <h2>¿Cómo funciona?</h2>
            <p>
              <b>Rellena tus datos básicos</b> — Precio, ahorro y plazo.
            </p>
            <p>
              <b>Compara ofertas reales</b> — Verás condiciones directamente de cada banco.
            </p>
            <p>
              <b>Elige tu banco favorito</b> — Sin llamadas, sin esperas.
            </p>
            <p>
              <b>Contrata directamente con el banco</b> — ¡Sin intermediarios!
            </p>
            <ButtonStart onClick={() => toggleModal()} data-fi-event="home-mortgages" title="Comenzar">
              Comenzar
            </ButtonStart>
          </BenefitInfo>
        </Benefit>

        <Section>
          <NewSectionInner>
            <SectionTitle title="Comparadores y artículos de interés" />

            <FaqItem
              basic
              title="Mejores hipotecas baratas: fijas, variables y mixtas."
              path="/hipotecas"
            />
            <FaqItem
              basic
              title="Mejores hipotecas mixtas: descubre cuál es la tuya."
              path="/hipotecas/mixtas"
            />
            <FaqItem
              basic
              title="Mejores hipotecas variables: elige la que más te conviene."
              path="/hipotecas/variables"
            />
            <FaqItem
              basic
              title="Mejores hipotecas fijas: compara y descubre la que mejor se adapta a ti."
              path="/hipotecas/fijas"
            />
          </NewSectionInner>
        </Section>

        <BottomCTAMortgages toggleModal={() => toggleModal()} />
      </LandingContent>
    );
  }
}

export default Mortgages;
